<template>
  <div
    :class="
      bem({
        'background-': props.block.contentLoopSectionFormatting.background,
        'width-': props.width
      })
    "
  >
    <div :class="bem('title-container')">
      <InteractiveListTitle
        v-if="props.block.media"
        :title="props.block.title"
        :media="props.block.media"
      />
      <div v-else-if="props.block.title" :class="bem('basic-title')">
        <VisionHeading size="h1" tag="h2">
          {{ props.block.title }}
        </VisionHeading>
      </div>
      <div v-else-if="$slots.title" :class="bem('basic-title')">
        <slot name="title" />
      </div>
    </div>
    <div
      v-if="props.block.items"
      :class="bem('items-container')"
    >
      <template
        v-for="(item, index) in props.block.items"
        :key="item.id"
      >
        <InteractiveListItem
          :item="item"
          :background="props.block.contentLoopSectionFormatting.background"
          :width="props.width"
          @open-overlay="handleOpenOverlay(index)"
        />
      </template>
    </div>
  </div>
  <InteractiveListOverlay
    v-if="openOverlay"
    :id="props.block.id"
    :items="props.block.items"
    :active-index="carouselActiveIndex"
    @close="handleCloseOverlay"
  />
</template>

<script setup lang="ts">
const bem = useBEM('InteractiveList')

interface InteractiveListProps {
  block: {
    id: string
    title: string
    media: any
    items: any[]
    contentLoopSectionFormatting: {
      background: string
    }
  }
  width?: 'full' | 'narrow'
}

const props = withDefaults(defineProps<InteractiveListProps>(), {
  width: 'full'
})

const carouselActiveIndex = ref(0)
const openOverlay = ref(false)

function handleOpenOverlay(index: number) {
  carouselActiveIndex.value = index
  openOverlay.value = true
}

function handleCloseOverlay() {
  openOverlay.value = false
}
</script>

<style lang="postcss">
.InteractiveList {
  @apply relative w-full;
}

.InteractiveList__title-container {
  @apply overflow-clip max-w-[100vw];
}

.InteractiveList__basic-title {
  @apply global-wrapper-large mb-10;
}

.InteractiveList__title-highlight {
  @apply text-grey-600;
}

.InteractiveList--background-dark {
  @apply bg-black text-white;
}

.InteractiveList--width-narrow {
  @apply pt-10;

  .InteractiveList__basic-title {
    @apply global-wrapper;
  }
}

.InteractiveList__items-container {
  @apply overflow-clip max-w-[100vw]
}
</style>
